module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/186.0f8a3743.png";